import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import 'malihu-custom-scrollbar-plugin';

gsap.registerPlugin(ScrollTrigger);

// 📌 keep track of our own triggers
let horizontalTriggers = [];

function debounce(fn, wait) {
    var timeout;
    wait = wait || 200;
    return function () {
        var ctx = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            fn.apply(ctx, args);
        }, wait);
    };
}

function setPlaceholderHeights() {
    document.querySelectorAll('.-scroll-gsap .media-placeholder').forEach(placeholder => {
        const img = placeholder.querySelector('img');
        if (!img || !img.complete) return;
        const w = img.getBoundingClientRect().width;
        placeholder.style.height = `${w}px`;
    });
}

/**
 * Initialize or re-init only our horizontal scroll triggers
 */
function initHorizontalScroll() {
    // 🗑 kill previous horizontal triggers
    horizontalTriggers.forEach(t => t.kill());
    horizontalTriggers = [];

    document.querySelectorAll('.-scroll-gsap .media-placeholder').forEach(placeholder => {
        const box = placeholder.querySelector('.media-box');
        if (!box) return;

        const img = box.querySelector('img');
        if (!img || !img.complete) return;

        const overflowX = img.getBoundingClientRect().width - placeholder.clientWidth;
        gsap.set(img, { x: 0 });

        if (overflowX > 0) {
            const tween = gsap.to(img, { x: -overflowX, ease: 'none' });

            // ✅ create and store trigger
            const trigger = ScrollTrigger.create({
                animation: tween,
                trigger:   placeholder,
                start:     'top top',
                end:       'bottom bottom',
                scrub:     true,
                pin:       box,
                pinSpacing:false
            });

            horizontalTriggers.push(trigger);

        } else {
            // pin only (no animation)
            const trigger = ScrollTrigger.create({
                trigger:    placeholder,
                start:      'top top',
                end:        'bottom bottom',
                pin:        box,
                pinSpacing: false
            });
            horizontalTriggers.push(trigger);
        }
    });
}

function disableHorizontalScroll() {
    // Remove all GSAP scroll triggers
    horizontalTriggers.forEach(t => t.kill());
    horizontalTriggers.length = 0;

    // Clear inline styles on placeholders and images
    document.querySelectorAll('.-scroll-gsap .media-placeholder').forEach(placeholder => {
        placeholder.style.height = '';
        const img = placeholder.querySelector('img');
        if (img) {
            gsap.set(img, {clearProps: 'transform'});
        }
    });
}

/**
 * Main entry point:
 * - On mobile (<768px) initialize or update GSAP scroll and custom scrollbar.
 * - On desktop (>=768px) destroy both.
 */
function refreshAll() {
    const isMobile = window.innerWidth < 768;

    if (isMobile) {
        // GSAP-driven horizontal scroll
        setPlaceholderHeights();
        initHorizontalScroll();

        setTimeout(()=> {
            horizontalTriggers.forEach(t => t.refresh());
        }, 100)

        // ===== Supplement: initialize/update custom scrollbar on mobile =====
        $(".-scroll-simple .media-box").each(function () {
            const $el = $(this);
            const isInit = !!$el.data("mCS");

            if (!isInit) {
                // initialize plugin if not yet
                $el.mCustomScrollbar({
                    axis: "x",
                    theme: "my-theme",
                    mouseWheel: {enable: false},
                    scrollButtons: {enable: false},
                    advanced: {autoExpandHorizontalScroll: true}
                });
            } else {
                // otherwise update existing instance
                $el.mCustomScrollbar("update");
            }
        });
        // ===================================================================

    } else {
        // Tear down GSAP scroll on desktop
        disableHorizontalScroll();

        // ===== Supplement: destroy custom scrollbar on desktop =====
        $(".-scroll-simple .media-box").each(function () {
            const $el = $(this);
            if ($el.data("mCS")) {
                $el.mCustomScrollbar("destroy");
            }
        });
        // ===================================================================
    }
}

// Run on initial load (give images time to load)
window.addEventListener('load', () => {
    setTimeout(refreshAll, 50);
});

// Re-run on resize, debounced
window.addEventListener('resize', debounce(refreshAll, 100));
